export interface Login {
	email?: string;
	password?: string;
}

export interface UserIpData {
	ipNumber: string;
	idUser: number;
}

export interface LoginResponse {
	data?: DataUser;
	traceId?: string;
	at?: Date;
}

export interface UsersResponse {
	data?: UsersResponse;
	traceId?: string;
	at?: Date;
}

export interface DataUser {
	token?: string;
	expiration?: Date;
	authContext?: AuthContext;
	dealerships?: Dealerships[];
	ownedClientIds?: number[];
	hasAccessToAllClients?: boolean;
	userType?: number;
}

export interface Dealerships {
	id: string;
	parentDealershipId: string;
	name: string;
	address: string;
	phoneNumber: string;
	city: string;
	state: string;
	lat: number;
	long: number;
	deliveryType: string;
	deliveryRadius: number;
	groupDescription: string;
	influenceRadius: number;
	priceGroupId: string;
	locationType: string;
	brand: string;
	showPortal: boolean;
	vehicles: any[];
	brandId: number;
	dealershipType: number;
}

export interface AuthContext {
	id?: number;
	brandId?: number;
	role?: string;
	dealershipId?: string;
	name?: string;
	originAssistedSale?: string;
}

export interface ContactUser {
	id: number;
	name: string;
	surname: string;
	contactType: number;
	documentType: number;
	document: string;
	email: string;
	cellphone: string;
	addressCity: string;
}

export interface UsersPayloadKa {
	userId: number;
	sellerId: number;
	origin: string;
	renewalContractRentId: null;
	purchaseType: boolean;
}

export interface UsersPayload {
	name?: string;
	addressDepartment: string;
	identificationType?: string;
	secondname?: string;
	document?: string;
  documentType?: number;
	email?: string;
	emailConfirmation?: string;
	cellphone?: string;
	password?: string;
	passwordConfirmation?: string;
	hasAcceptedPrivacyPolicy?: boolean;
	hasAcceptedNewsletter?: boolean;
	clientType?: number;
	basketId?: string;
	verifyingDigit?: string;
	dateCompanyEstablishment?: Date;
}

export interface UserData {
	id?: number;
	emailPIN?: string;
}

export interface SendPassRecoveryPayload {
	captcha?: string;
	email?: string;
}

export interface MailUpdatePayload {
	email?: string;
	emailConfirmation?: string;
}
export enum RolesUser {
	CONSULTANT = 'CONSULTANT',
	SELLER = 'SELLER',
	KA = 'KA',
	VE = 'VE',
	SELF_SERVICE = 'SELF_SERVICE',
	FLEET_ADMIN = 'FLEET_ADMIN'
}
